export default __webpack_public_path__ + "ba26312.png";